import { call, put, select } from 'typed-redux-saga';

import { NOTIFICATIONS_MAP, notify } from '../../../../shared/features/notifications/ps-notifications';
import { replace, SCREENS } from '../../../../shared/helpers/navigation';
import { disconnectConferenceAction, setCloseRoomInitiatedBySelf } from '../../features/conference/slice';
import { selectCloseRoomInitiatedBySelf } from '../../selectors';
import { DisconnectReason, NotificationId } from '../../types';
import { shouldShowRoomWasClosedNotification } from './close-room-notification';
import { handleDisconnect } from './handle-disconnect';

export function* handleCloseRoom() {
    const closeRoomInitiatedBySelf = yield* select(selectCloseRoomInitiatedBySelf);

    yield put(
        disconnectConferenceAction({
            source: DisconnectReason.CLOSE_ROOM,
        })
    );
    yield call(replace, SCREENS.CREATE_CALL, {});
    yield call(handleDisconnect);
    yield put(setCloseRoomInitiatedBySelf(false));

    if (shouldShowRoomWasClosedNotification(closeRoomInitiatedBySelf)) {
        yield put(notify(NOTIFICATIONS_MAP[NotificationId.PERMISSIONS_CLOSE_ROOM]()));
    }
}
